import React from "react";

import styled from "styled-components";

import { DustbinIcon } from "../svgExport";
import { displayValueOrNA } from "../utils";

function DocFilePreview(props: any) {
  return (
    <DocFilePreviewContainer>
      <DocFilePreviewListItem>
        <span className="fileName">{props.file?.file_name || ""}</span>
        <CrossIconContainer
          onClick={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) =>
            props.onDelete &&
            props.onDelete(
              e,
              props?.file?.download ||
                props?.file?.preview ||
                props?.file?.file_reference
            )
          }
        >
          <DustbinIcon />
        </CrossIconContainer>
      </DocFilePreviewListItem>
      <div style={{ display: "flex" }}>
        <div className="text-1">
          <span className="subtext-1">File Tppe</span>
          <span className="subtext-2">
            {displayValueOrNA(props.file?.file_types?.types)}
          </span>
        </div>
        <div className="text-2">
          <span className="subtext-1">
            {displayValueOrNA(props.file?.created_by)}
          </span>
          <span className="subtext-2">Admin Transport</span>
        </div>
      </div>
    </DocFilePreviewContainer>
  );
}

const DocFilePreviewContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const CrossIconContainer = styled.div`
  display: flex;
  width: 24px;
  height: 24px;
  padding: 4px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 100px;

  right: 4px;
  top: 4px;
  cursor: pointer;
`;

const DocFilePreviewListItem = styled.li`
  width: 50%;
  display: flex;
  padding: 5px 10px;
  /* flex-direction: column; */
  align-items: flex-start;
  gap: 10px;
  /* flex: 1 0 0; */
  border-radius: 6px;
  border: 1px solid #e5e7e9;
  background: #f9fafb;
  justify-content: space-between;
  > span {
    font-size: 12px;
    color: #6a7378;
  }
`;

export default DocFilePreview;
